// This file is the default environment for `npm start` and `ng serve`.
// It points the locally-running frontend at the cloud Dev backend (salmonbush).
// `ng build` (prod) replaces it with `environment.prod.ts`.
// `ng build --configuration=qa` replaces it with `environment.qa.ts`.
// File replacements are configured in `angular.json`.

export const environment = {
    // SPEC-web-planner-027 AC-8: DEV keeps Angular's development mode on purpose (debugging, window.ng, dev-mode checks).
    // QA and prod build with production: true.
    production: false,
    // SPEC-web-planner-024 AC-10 (towards GAP-MEET-UX-266): the published Terms of Service and Privacy Policy URLs.
    // SPEC-web-planner-027 AC-10: published by Awvent (28 Oct). The sign-in and /activate sentences link to them,
    // in a new tab. Never '#' or 'javascript:'. Set either to '' and the sentence names the document without a link.
    legal: { termsUrl: 'https://www.awvent.com/terms-of-service', privacyUrl: 'https://www.awvent.com/privacy-policy' },
    // isDemoBuild gates the prototype-only role-routing chooser (signin State 6).
    // true here (dev) so the `?demo=1` affordance is reachable during design
    // verification; false in prod so production users can never see it.
    // SESSION-meet-ux-002 (GAP-MEETUX-015).
    isDemoBuild: true,
    firebase: {
      apiKey: 'AIzaSyDZsXZnhiQfXx6te7I9oTpGimGyUO_ORNE',
      authDomain: 'awvent-16412.firebaseapp.com',
      projectId: 'awvent-16412',
      storageBucket: 'awvent-16412.appspot.com',
      messagingSenderId: '537578668454',
      appId: '1:537578668454:web:e17487497239e2ade14f67',
      measurementId: 'G-BK649G934L'
    },
    api: {
      businessAccounts: 'https://business-accounts-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      contacts:         'https://contacts-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      documents:        'https://documents-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      meetings:         'https://meetings-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      openaiConnector:  'https://openai-connector-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      products:         'https://product-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      subscriptions:    'https://subscriptions-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      users:            'https://users-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      // GAP-BACKEND-IS-006 — Evidence Density microservice (session ED Timeline).
      // ⚠️ evidence-density-api is NOT yet provisioned on dev (see awvent-backend
      // deployment.md); hostname assumed to follow the salmonbush convention.
      // Until the app is live, EvidenceDensityService calls fail and the ED tab
      // degrades to its honest "coming online" state. Correct this URL if the
      // provisioned hostname differs.
      evidenceDensity:  'https://evidence-density-api.salmonbush-bc151c49.centralus.azurecontainerapps.io',
      // GAP-WEBPLANNER-068 / SPEC-webplanner-052 — SHA presenter-alert API.
      // Base host only (no /api/v1); SessionHealthService appends the route.
      // Live + healthy on dev (revision sha-api--0000004, /swagger 200,
      // verified 2026-07-25). Poll leg GET /api/v1/Incident/sessions/{id}.
      sha:              'https://sha-api.salmonbush-bc151c49.centralus.azurecontainerapps.io'
    },
    // agents-api (Ivaan). Base path INCLUDES /api/v1 — clients append the bare
    // route (e.g. `/Agent/Conversation/Message`). GAP-WEBPLANNER-019.
    agentsApiBaseUrl: 'https://agents-api.salmonbush-bc151c49.centralus.azurecontainerapps.io/api/v1',

    // SPEC-webplanner-025 AC-12 — base origin the OAuth redirect URI is
    // built from (`{oauthRedirectBase}/oauth/{provider}/callback`). MUST
    // match one of the redirect URIs registered on the Google OAuth client
    // `Awvent Meet — Rep Gmail send (per-env)`.
    //
    // SPEC-web-planner-021: the DEV custom domain (mapped 2026-10-18). In this app the
    // value is read only as the join-link base (join-link.ts); the OAuth redirect itself
    // is built by users-api from its OAUTH_REDIRECT_BASE, kept equal to this by hand.
    // The old azurewebsites host still serves, but OAuth connect works on this domain only
    // (the callback lands here, and sign-in state is per origin).
    oauthRedirectBase: 'https://meet-dev.awvent.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
